module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.hideBlock
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "profile-head"
  }, [_c('div', {
    staticClass: "profile-top",
    style: ({
      backgroundImage: 'url(' + _vm.userDetail.coverImage + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "profile-bottom"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('Tooltip', {
    attrs: {
      "content": '@' + _vm.userDetail.userName,
      "placement": "right-end"
    }
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary pointer",
      "size": "100"
    },
    on: {
      "click": function($event) {
        return _vm.openNewWindowViewImage(_vm.userDetail.image)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image != null),
      expression: "userDetail.image != null"
    }],
    attrs: {
      "src": _vm.userDetail.image,
      "alt": _vm.userDetail.userName
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetail.image == null),
      expression: "userDetail.image == null"
    }],
    staticClass: "font-50 white--text"
  }, [_vm._v("\n                                                " + _vm._s(_vm.userDetail.userName != null ? _vm.userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                            ")])])], 1), _vm._v(" "), _c('Modal', {
    model: {
      value: (_vm.isShowViewImageModal),
      callback: function($$v) {
        _vm.isShowViewImageModal = $$v
      },
      expression: "isShowViewImageModal"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.userDetail.image
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-list-content mb-5"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('h3', {
    staticClass: "fw-700"
  }, [_vm._v(_vm._s(_vm.userDetail.nickName) + " (" + _vm._s(_vm.userDetail.reputationScore) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "font-16 fw-500 mt-3"
  }, [_c('span', {
    staticClass: "mx-3"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-at")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.userDetail.userName))])], 1), _vm._v(" "), _c('span', [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fas fa-calendar-alt")]), _c('span', {
    staticClass: "ml-1"
  }, [_vm._v(_vm._s(_vm.regTimeFormat(_vm.userDetail.regTime)))])], 1)])])])])])])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "mb-5": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "inbox-sidebar",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": "",
      "lg3": "",
      "xl2": ""
    }
  }, [_c('div', {
    staticClass: "inbox-head"
  }, [_c('div', {
    staticClass: "mailbox-items-warp"
  }, [_c('div', {
    staticClass: "app-card"
  }, [_c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('following')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("group_add")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("follow.following")) + "(" + _vm._s(_vm.followingNum) + ")\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.getMenuData('followers')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("group")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("follow.followers")) + "(" + _vm._s(_vm.followerNum) + ")\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "d-none",
    on: {
      "click": function($event) {
        return _vm.getMenuData('referrals')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("accessibility")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("follow.referrals")) + "(" + _vm._s(_vm.userDetail.invitationNumber) + ")\n                                                    ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticClass: "d-none",
    on: {
      "click": function($event) {
        return _vm.getMenuData('collections')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fa fa-star")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                                                        " + _vm._s(_vm.$t("follow.collections")) + "(" + _vm._s(_vm.totalPostingNum) + ")\n                                                    ")])], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "inbox-content",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('div', {
    staticClass: "inbox-content-wrap"
  }, [_c('v-card', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowFollowing),
      expression: "isShowFollowing"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.followingList), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-3 mb-3 app-card"
    }, [_c('div', {
      staticClass: "text-xs-center follow-w mb-3 mt-2 profile-card-bg",
      style: ({
        backgroundImage: 'url(' + user.coverImage + ')'
      })
    }, [_c('v-avatar', {
      staticClass: "pointer mt-4",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                                                          " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                                        ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "user-list-content"
    }, [_c('div', {
      staticClass: "text-xs-center pt-2"
    }, [_c('h4', {
      staticClass: "fw-bold pointer",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v(_vm._s(user.nickName))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(user.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center mb-2"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.userId != _vm.userId),
        expression: "user.userId != userId"
      }]
    }, [_c('v-btn', {
      staticClass: "primary",
      attrs: {
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.following(user.userId)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? true : false),
        expression: "user.status == '1' ? true : false"
      }]
    }, [_vm._v("\n                                                                    " + _vm._s(_vm.$t("common.unfollow")) + "\n                                                                ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? false : true),
        expression: "user.status == '1' ? false : true"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "#FFFFFF"
      }
    }), _vm._v("\n                                                                    " + _vm._s(_vm.$t("common.follow")) + "\n                                                                ")], 1)])], 1)])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowFollowers),
      expression: "isShowFollowers"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.followerList), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-3 mb-3 app-card"
    }, [_c('div', {
      staticClass: "text-xs-center follow-w mb-3 mt-2 profile-card-bg",
      style: ({
        backgroundImage: 'url(' + user.coverImage + ')'
      })
    }, [_c('v-avatar', {
      staticClass: "pointer mt-4",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                                                          " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                                        ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "user-list-content"
    }, [_c('div', {
      staticClass: "text-xs-center pt-2"
    }, [_c('h4', {
      staticClass: "fw-bold pointer",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v(_vm._s(user.nickName))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(user.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center mb-2"
    }, [(user.userId != _vm.userId) ? _c('div', [_c('v-btn', {
      staticClass: "primary",
      attrs: {
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.follower(user.userId)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? true : false),
        expression: "user.status == '1' ? true : false"
      }]
    }, [_vm._v("\n                                                                    " + _vm._s(_vm.$t("common.unfollow")) + "\n                                                                ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? false : true),
        expression: "user.status == '1' ? false : true"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "#FFFFFF"
      }
    }), _vm._v("\n                                                                    " + _vm._s(_vm.$t("common.follow")) + "\n                                                                ")], 1)])], 1) : _vm._e()])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowReferrals),
      expression: "isShowReferrals"
    }],
    staticClass: "ml-3 mr-3"
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.referralList), function(user, index) {
    return _c('div', {
      key: index,
      staticClass: "mr-3 mb-3 app-card"
    }, [_c('div', {
      staticClass: "text-xs-center follow-w mb-3 mt-2 profile-card-bg",
      style: ({
        backgroundImage: 'url(' + user.coverImage + ')'
      })
    }, [_c('v-avatar', {
      staticClass: "pointer mt-4",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image != null),
        expression: "user.image != null"
      }],
      attrs: {
        "src": user.image,
        "alt": user.userName
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.image == null),
        expression: "user.image == null"
      }],
      staticClass: "headline white--text"
    }, [_vm._v("\n                                                          " + _vm._s(user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : '') + "\n                                                        ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "user-list-content"
    }, [_c('div', {
      staticClass: "text-xs-center pt-2"
    }, [_c('h4', {
      staticClass: "fw-bold pointer",
      on: {
        "click": function($event) {
          return _vm.goUserData(user.userName)
        }
      }
    }, [_vm._v(_vm._s(user.nickName))]), _vm._v(" "), _c('span', [_vm._v("@" + _vm._s(user.userName))])]), _vm._v(" "), _c('div', {
      staticClass: "text-xs-center mb-2"
    }, [(user.userId != _vm.userId) ? _c('div', [_c('v-btn', {
      staticClass: "primary",
      attrs: {
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.referralFollow(user.userId)
        }
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? true : false),
        expression: "user.status == '1' ? true : false"
      }]
    }, [_vm._v("\n                                                                    " + _vm._s(_vm.$t("common.unfollow")) + "\n                                                                ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.status == '1' ? false : true),
        expression: "user.status == '1' ? false : true"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "plus-round",
        "color": "#FFFFFF"
      }
    }), _vm._v("\n                                                                    " + _vm._s(_vm.$t("common.follow")) + "\n                                                                ")], 1)])], 1) : _vm._e()])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowCollections),
      expression: "isShowCollections"
    }]
  }, [_vm._l((_vm.postingList), function(posting, index) {
    return _c('div', {
      staticClass: "media-listing"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', {
      staticClass: "media border-bottom-light-1"
    }, [(posting.postingImg != '') ? _c('span', {
      staticClass: "rounded-circle mr-4 img-responsive posting-image",
      domProps: {
        "innerHTML": _vm._s(posting.postingImg)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h3', {
      staticClass: "fw-bold",
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(posting.postingTitle))])]), _vm._v(" "), _c('p', {
      staticClass: "mb-0"
    }, [(posting.postingContent.length = 0) ? _c('span') : _vm._e(), _vm._v(" "), (posting.postingContent.length < 30) ? _c('span', [_vm._v("\n                                                        " + _vm._s(posting.postingContent) + "\n                                                    ")]) : _c('span', [_vm._v(_vm._s(posting.postingContent) + "……")])]), _vm._v(" "), _c('div', {
      staticClass: "social-list clearfix mb-4"
    }, [_c('ul', {
      staticClass: "list-inline d-inline-block"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_up_alt")]), _c('span', [_vm._v(_vm._s(posting.postingGoodnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("thumb_down_alt")]), _c('span', [_vm._v(_vm._s(posting.postingStepnums))])], 1), _vm._v(" "), _c('li', [_c('v-icon', {
      attrs: {
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.getPostingById(posting.postingId, posting.postingUserId)
        }
      }
    }, [_vm._v("fa fa-comment")]), _c('span', [_vm._v(_vm._s(posting.postingCountComments))])], 1)])])])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.postingList.length > 0),
      expression: "postingList.length > 0"
    }]
  }, [_c('Page', {
    staticClass: "mt-2 mb-5 text-xs-center",
    attrs: {
      "total": _vm.totalPostingNum,
      "pageSize": 5,
      "size": "small",
      "transfer": ""
    },
    on: {
      "on-change": _vm.getPostingByPage
    }
  })], 1)], 2)])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b58e94e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/UserFollow.vue
// module id = 432
// module chunks = 0